export const OWNER_ORGANIZATION_EMAIL = "visualize@bafu.admin.ch";
